<template>
<div class="segment-main">
  <h1 class="title has-text-centered">Faceoffs PvP </h1>
  <div class="segment">
      <div class="columns">
        <div class="column">
          <label class="label">Lane</label>
          <div class="control">
            <div class="select">
              <select v-model="lane" @change="fetchStats">
                <option value=0>All</option>
                <option value="Left">Left</option>
                <option value="Center">Center</option>
                <option value="Right">Right</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column">
          <label class="label">Zone</label>
          <div class="control">
            <div class="select">
              <select v-model="zone" @change="fetchStats">
                <option value=0>All</option>
                <option value="Offensive">Offensive</option>
                <option value="Offensive">Neutral</option>
                <option value="Offensive">Defensive</option>
              </select>
            </div>
          </div>
        </div>
      </div>
  </div>
  <span v-if="this.tableData.length <= 0"><h2 class="segment title has-text-centered">No data or Loading...</h2></span>
  <div class="segment" v-for="player in this.tableData" v-bind:key="player.player">
    <h1 class="subtitle has-text-centered">{{player.player}}</h1>
    <table class="table main-table">
      <thead>
        <th>VS</th> 
        <th>Taken</th> 
        <th>Win</th>
        <th>Loss</th>
        <th>Win %</th>
      </thead>
          <tbody>
            <tr v-for="opp in player.vs" v-bind:key="opp.away_player">
              <td>{{opp.away_player}}</td>
              <td>{{opp.fo_taken}}</td>
              <td>{{opp.fo_win}}</td>
              <td>{{opp.fo_loss}}</td>
              <td>{{opp.fo_win_percentage}}</td>
            </tr>
          </tbody>
      </table>
    </div>
</div>
</template>

<script>
export default {
  props: {
    game_id: { type: Number, required: true },
    opponent: { type: Number, required: true }
  },
  data () {
    return {
      tableData: [],
      lane: 'Left',
      zone: 0,
      url: 'https://devilsapi.roblutken.com/api/app/season-stats/faceoffs-by-player',
      postData: [{
        game_id: 0,
        opponent: 0,
        lane: '',
        zone: ''
      }]
    }
  },
  methods: {
    fetchStats () {
      this.tableData = []
      this.postData[0].lane = this.lane
      this.postData[0].zone = this.zone
      this.postData[0].game_id = this.game_id
      this.postData[0].opponent = this.opponent
      console.log(this.postData[0])
      this.$http
      .post(this.url, this.postData[0], {
        headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
      })
      .then(
        response => {
          console.log('response was: ' + response.data)
          this.tableData = response.data['faceoffs_by_player']
          console.log(this.tableData)
        },
        response => {}
      )
    }
  },
  watch: {
    game_id: {
      handler: function (endpoint) {
        this.fetchStats()
      },
      immediate: true
    },
    opponent: {
      handler: function (postData) {
        this.fetchStats()
      },
      immediate: true
    }
  },
  created: function () {
    this.fetchStats()
  }
}
</script>

<style lang="scss" scoped>
thead, th {
    background-color: #8b0505d1;
}
.table tr:hover {
    background-color: #8b0505d1;
    color: #fff;
    margin: 0 auto;
}
.table thead td, .table thead th{
  color: #fff;
}
.devils{
  background-color: #8b0505d1;
  color: #fff;
}
/* scrolltable rules */
table  {     width:100%; 
    margin-left:auto; 
    margin-right:auto;  overflow: auto; }
th div { margin-top: -20px; position: absolute; }

/* design */
table { border-collapse: collapse; }
tr:nth-child(even) { background: #EEE; }
.main-table{
  max-width: 90%
}
.segment-main {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.segment {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 70%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.small-box {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.segment-main h1 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}
.segment-main h1 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}
.segment h2 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 2em;
}
.segment p{
  font-size:1.2em;
  text-transform: uppercase;
}
.stat-title{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.3rem;
  margin: 1rem 0rem;
}
.stat-category{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.5rem;
  margin: 1rem 0rem;
}
.stat-number{
  font-family: 'Heebo', sans-serif;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.3rem;
  margin: 1rem 0rem;
  color:black;
}
</style>



// WEBPACK FOOTER //
// faceoffs-pvp.vue?9854a5c8